import { http } from '../../config/axios'

export default function postMotorCredito(motorCredito: any): Promise<string> {
  return http
    .post('api/motorcredito', motorCredito)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post motor credito', error)
      throw Error(error.response.data)
    })
}
